export default {
  // Endpoints
  loginEndpoint: '/auth/discord/login',
  loginCallbackEndpoint: '/auth/discord/callback',
  refreshEndpoint: '/auth/discord/refresh',
  websocketAuthToken: '/auth/ws-token',

  // This will be prefixed in authorization header with token
  // e.g. Authorization: Bearer <token>
  tokenType: 'Bearer',

  // Value of this property will be used as key to store JWT token in storage
  storageTokenKeyName: 'onclock-accessToken',
  storageRefreshTokenKeyName: 'onclock-refreshToken',
  userDataKeyName: 'onClockUserData',
}
